import React, { useCallback, useState } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';

import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';

import { DonationsModal } from '../../donations-modal';
import { IconContainer } from '../styled';

import { Total, TotalLabel, TotalsRow } from './styled';
import { IDonationsRowProps } from './types';

const DonationsRow: React.FC<IDonationsRowProps> = ({
  isLoading,
  iconAriaLabel,
  totalCents,
  message,
  modalContent,
}) => {
  const [showDonationsInfoModal, setShowDonationsInfoModal] = useState(false);

  const onOpenCallback = useCallback(() => {
    if (!modalContent) {
      return;
    }
    setShowDonationsInfoModal(true);
  }, [setShowDonationsInfoModal, modalContent]);

  const onCloseCallback = useCallback(() => {
    setShowDonationsInfoModal(false);
  }, [setShowDonationsInfoModal]);

  return (
    <>
      <TotalsRow>
        {isLoading ? (
          <CurrencyLineSkeleton />
        ) : (
          <>
            <TotalLabel>
              {message}
              {iconAriaLabel && (
                <IconContainer aria-label={iconAriaLabel} type="button" onClick={onOpenCallback}>
                  <Icon icon="info" color="icon-default" width="14px" aria-hidden />
                </IconContainer>
              )}
            </TotalLabel>
            <Total data-testid="total-donation">
              <Currency amount={totalCents} />
            </Total>
          </>
        )}
      </TotalsRow>
      {modalContent && (
        <DonationsModal
          isOpen={showDonationsInfoModal}
          onCloseCallback={onCloseCallback}
          title={modalContent.title}
          modalAppearanceEventMessage={modalContent.modalAppearanceEventMessage}
        >
          {modalContent.body}
        </DonationsModal>
      )}
    </>
  );
};

export default DonationsRow;
